<template>
    <div class="payment-cc">
        <StripeElements v-slot="{ elements }" ref="elms" :stripe-key="stripeKey" :instance-options="instanceOptions" :elements-options="elementsOptions">
            <StripeElement ref="card" type="card" :elements="elements" :options="cardOptions"/>
        </StripeElements>
    </div>
</template>

<script>
import { StripeElement, StripeElements } from 'vue-stripe-elements-plus'

export default {
    name: 'CreditCard',

    components: {
        StripeElements,
        StripeElement
    },

    props: {
        color: {
            default: '#d7d4c3',
            type: String
        },
        placeHolderColor: {
            default: '#6c757d',
            type: String
        }
    },
    data () {
        return {
            errorMessage: '',
            stripeKey: this.$config.stripeKey,
            instanceOptions: {
                // https://stripe.com/docs/js/initializing#init_stripe_js-options
            },
            elementsOptions: {
                // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
            },
            cardOptions: {
                style: {
                    base: {
                        color: this.color,
                        iconColor: '#83be55',
                        lineHeight: '22px',
                        fontFamily: 'Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: this.placeHolderColor
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                },
                hidePostalCode: true
                // https://stripe.com/docs/stripe.js#element-options
            }
        }
    },
    mounted () {
        this.$emit('ready', true)
    },
    methods: {
        async getCreditCardToken () {
            const groupComponent = this.$refs.elms
            const cardComponent = this.$refs.card
            // Get stripe element
            const cardElement = cardComponent.stripeElement

            // Access instance methods, e.g. createToken()
            return await groupComponent.instance.createToken(cardElement).then((result) => {
                return result
            })
        }
    }
}
</script>
